export enum OnboardingProgressStepStatus {
  CHECKED = 'checked',
  UNCHECKED = 'unchecked',
}

export type OnboardingProgressStepModification = {
  id: string;
  status: OnboardingProgressStepStatus;
};
